import axios from "axios";
import { API_URL } from "../constants/config";

const createAxiosInstance = (token, customUrl = null) => {

  if (!token || typeof token !== "string") {
    return Promise.reject(new Error("ACCESS TOKEN REQUIRED"));
  }

  const baseURL = typeof customUrl === "string" && customUrl.length > 0
    ? customUrl
    : `${API_URL}ops/api/`;

  if (typeof baseURL !== "string" || baseURL.trim() === "") {
    return Promise.reject(new Error("INVALID BASE URL"));
  }

  const axiosInstance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json", // Default content type
    },
  });

  // Adding Authorization Token Dynamically
  axiosInstance.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;